import { useMediaQuery } from '@mui/material';
import _ from 'lodash';
import { useState } from 'react';
import theme from 'theme';

/**
 * Hook xử lý trong bảng
 * @param {*} currentPageSlice : giá trị page hiện tại ở trong store
 */
const useTableCC = (currentPageSlice = 0) => {
    const isLargePC = useMediaQuery(theme.breakpoints.up('xl'))
    const [selected, setSelected] = useState([])
    const count = 1
    const [currentPage, setCurrentPage] = useState(currentPageSlice)
    const limit = 5

    /**
     * Chọn tất cả bản ghi trong danh sách
     * -----
     * Cập nhật: [240801] - Thêm thông tin lọc danh sách bản ghi
     * filter: { name: column_name_filter, value: value_of_column_filter }
     * Cập nhật: [241122] - Thay đổi logic
     * @param {*} event : Sự kiện
     * @param {*} data  : Danh sách bản ghi
     * @param {*} cellMap : Cột lấy thông tin làm id
     * @param {*} conditionsSub: Điều kiện mảng phụ để lọc giá trị
     */
    const handleSelectAllClick = (event, data, cellMap, conditionsSub = []) => {
        // Lọc bản ghi theo điều kiện conditionsSub
        let _data = data
        for(let i = 0; i < conditionsSub.length; i++){
            _data = _data?.filter(value => value[conditionsSub[i]?.name] === conditionsSub[i]?.value)
        }
        // Danh sách bản ghi được chọn
        let newSelected = _data.map((row) => row[cellMap])

        if (event.target.checked) {
            setSelected(prev => _.uniq([...selected, ...newSelected]));     // Thêm bản ghi được chọn vào danh sách
        } else {
            setSelected(prev => prev.filter(id => !newSelected.includes(id)));      // Xóa bản ghi khỏi danh sách
        }
    };

    const handleClick = (checked, id) => {
        if (checked) {
            setSelected([...selected, id])
        } else {
            const selectedIndex = selected.indexOf(id);
            let newSelected = [];
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, id);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    selected.slice(0, selectedIndex),
                    selected.slice(selectedIndex + 1),
                );
            }

            setSelected(newSelected);
        }
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    const handleChangePage = (e, page) => {
        setCurrentPage(page-1)
    }

    return {
        selected,
        handleSelectAllClick,
        isSelected,
        handleClick,
        handleChangePage,
        count,
        sizeRow: isLargePC ? 'medium' : 'small',
        currentPage,
        setCurrentPage,
        limit,
        setSelected
    }

}

export default useTableCC